import { useRoutes } from "react-router-dom";

import routes from "./routes";
import createEmotionCache from "@/utils/createEmotionCache";
import AppProviders from "@/components/Providers";
import SentryErrorBoundary from "@/utils/sentryErrorBoundary";

const clientSideEmotionCache = createEmotionCache();

function App({ emotionCache = clientSideEmotionCache }) {
  const content = useRoutes(routes);
  return (
    <SentryErrorBoundary>
      <AppProviders emotionCache={emotionCache}>{content}</AppProviders>
    </SentryErrorBoundary>
  );
}

export default App;
